module.exports = __webpack_public_path__ + "static/media/ic_template_18.2ded7bfb.png";